import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Select } from 'antd';
import { LineChartOutlined, DollarOutlined, BarChartOutlined, CompassOutlined, LogoutOutlined, AppstoreOutlined, ExperimentOutlined, FileTextOutlined } from '@ant-design/icons';

import { useAuth } from '../../context/AuthContext';
import { FilterProvider, useFilters } from '../../context/FilterContext';
import logo from '../../assets/logo.png';
import scaleIcon from '../../assets/scale.png';

const { Sider, Content } = Layout;

function AppSidebar({ collapsed, setCollapsed, navigate, location, logout }) {
  const f = useFilters();
  const [openKeys, setOpenKeys] = useState([]);

  const menuItems = [
    { key: '/revenue', icon: <DollarOutlined />, label: 'Revenue' },
    { key: '/market', icon: <LineChartOutlined />, label: 'Market' },
    // { key: '/volume', icon: <BarChartOutlined />, label: 'Volume' },
    { key: '/dsm', icon: <img src={scaleIcon} alt="DSM" style={{ width: 16, height: 16, objectFit: 'contain' }} />, label: 'DSM' },
    { key: '/what-if', icon: <ExperimentOutlined />, label: 'Bidding Tool' },
    {
      key: 'reports',
      icon: <FileTextOutlined />,
      label: 'Reports',
      children: [
        { key: '/weekly-report', label: 'Weekly Report' },
        { key: '/monthly-report', label: 'Monthly Report' }
      ]
    },
    { key: '/explorer', icon: <CompassOutlined />, label: 'Explorer' },
  ];

  return (
    <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} width={200} theme="light"
      style={{ borderRight: '1px solid #e2e8f0', position: 'sticky', top: 0, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: collapsed ? '16px 8px' : 16, textAlign: 'center', borderBottom: '1px solid #e2e8f0', transition: 'all 0.2s' }}>
        <img src={logo} alt="Apraava" style={{ height: collapsed ? 20 : 28, width: 'auto', maxWidth: '100%', transition: 'all 0.2s' }} />
      </div>
      {!collapsed && (
        <div style={{ padding: '12px 16px' }}>
          {/* <div style={{ fontSize: 11, fontWeight: 600, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Plant Selection
          </div> */}
          <Select
            value={f.plantIds[0] || 1}
            onChange={(val) => f.setPlantIds([val])}
            style={{ width: '100%' }}
            options={[
              { value: 1, label: 'Andra Lake' }
            ]}
          />
        </div>
      )}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <Menu mode="inline" selectedKeys={[location.pathname]} items={menuItems}
          openKeys={openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
          onClick={({ key }) => {
            navigate(key);
            setOpenKeys([]);
          }}
          style={{ border: 'none', fontSize: 14 }} />
      </div>
      <div style={{ padding: 12, borderTop: '1px solid #e2e8f0' }}>
        <Button icon={<AppstoreOutlined />} onClick={() => navigate('/app-selection')} block style={{ fontSize: 14, marginBottom: 8 }}>
          {!collapsed && 'Switch App'}
        </Button>
        <Button icon={<LogoutOutlined />} onClick={logout} block danger ghost style={{ fontSize: 14 }}>
          {!collapsed && 'Logout'}
        </Button>
      </div>
    </Sider>
  );
}

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <FilterProvider>
      <style>{`
        /* Overrides to keep Reports text and dropdown arrow color black */
        .ant-menu-submenu-title {
          color: #000000 !important;
        }
        .ant-menu-submenu-open > .ant-menu-submenu-title {
          color: #000000 !important;
        }
        .ant-menu-submenu-title:hover {
          color: #000000 !important;
        }
        .ant-menu-submenu-arrow {
          color: #000000 !important;
        }
        .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow {
          color: #000000 !important;
        }
        .ant-menu-submenu-selected > .ant-menu-submenu-title {
          color: #000000 !important;
        }
        .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow {
          color: #000000 !important;
        }
      `}</style>
      <Layout style={{ minHeight: '100vh' }}>
        <AppSidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          navigate={navigate}
          location={location}
          logout={logout}
        />

        <Layout style={{ background: '#fff' }}>
          <Content style={{ margin: 0, padding: 0, background: '#fff', minHeight: '100vh' }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </FilterProvider>
  );
}
